import React, { useEffect, useState, useRef } from "react";
import {
  LightModeOutlined,
  DarkModeOutlined,
  Menu as MenuIcon,
  ArrowDropDownOutlined,
  MenuBookOutlined,
} from "@mui/icons-material";
import FlexBetween from "shared/FlexBetween";
import { useDispatch } from "react-redux";
import { setMode } from "state";
// import profileImage from "assets/images/profile.jpeg";
import {
  AppBar,
  Button,
  IconButton,
  Toolbar,
  Menu,
  MenuItem,
  useTheme,
  Avatar,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  CircularProgress,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { indigo } from "@mui/material/colors";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { getCalendarPdfUrl } from "shared/utils";
import useAuth from "./useAuth";
import useAWSDetails from "./useAWSDetails";

const Navbar = ({ user, isSidebarOpen, setIsSidebarOpen }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  // const [userRole, setUserRole] = useState("");
  const isOpen = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const [loggedUser, setLoggedUser] = useState([]);
  const [id, setId] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  // const [fetchedBucketName, setFetchedBucketName] = useState("");
  // const [fetchedRegion, setFetchedRegion] = useState("");
  const { userRole, loading } = useAuth();
  const apiCalledRef = useRef(false);
  // const apiAWSCalledRef = useRef(false);
  const { fetchedBucketName, fetchedRegion } = useAWSDetails();
  const lightTheme = createTheme({
    palette: {
      primary: indigo,
    },
  });
  const [handbookOpen, setHandbookOpen] = useState(false);
  const [handbookUrl, setHandbookUrl] = useState(null);
  const [handbookLoading, setHandbookLoading] = useState(false);
  const [handbookError, setHandbookError] = useState("");
  const [handbookAccepted, setHandbookAccepted] = useState(false);
  const [handbookAcceptedAt, setHandbookAcceptedAt] = useState(null);

  const getHandbookStorageKey = () => {
    const id = employeeId || loggedUser?.employeeId || "default";
    return `handbookAccepted_${id}`;
  };

  const loadHandbookAcceptance = () => {
    try {
      const raw = localStorage.getItem(getHandbookStorageKey());
      if (!raw) {
        setHandbookAccepted(false);
        setHandbookAcceptedAt(null);
        return;
      }
      const parsed = JSON.parse(raw);
      setHandbookAccepted(!!parsed.accepted);
      setHandbookAcceptedAt(parsed.acceptedAt || null);
    } catch {
      setHandbookAccepted(false);
      setHandbookAcceptedAt(null);
    }
  };

  useEffect(() => {
    if (employeeId) loadHandbookAcceptance();
  }, [employeeId]);

  const handleHandbookAcceptChange = (event) => {
    const checked = event.target.checked;
    if (checked) {
      const acceptedAt = new Date().toISOString();
      try {
        localStorage.setItem(
          getHandbookStorageKey(),
          JSON.stringify({ accepted: true, acceptedAt, employeeId: employeeId || loggedUser?.employeeId })
        );
      } catch {}
      setHandbookAccepted(true);
      setHandbookAcceptedAt(acceptedAt);
    }
  };

  const handleOpenHandbook = async () => {
    setHandbookOpen(true);
    setHandbookLoading(true);
    setHandbookError("");
    loadHandbookAcceptance();
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}handbooks/me`,
        { responseType: "blob", withCredentials: true }
      );
      const contentType = response.headers["content-type"] || "";
      if (contentType.includes("application/json")) {
        const text = await response.data.text();
        const parsed = JSON.parse(text);
        throw new Error(parsed.message || "Failed to load handbook");
      }
      const blobUrl = URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      setHandbookUrl((prev) => {
        if (prev) URL.revokeObjectURL(prev);
        return blobUrl;
      });
    } catch (error) {
      const status = error?.response?.status;
      if (status === 404) {
        setHandbookError("No handbook is set up for your country yet.");
      } else if (status === 401) {
        setHandbookError("Session expired. Please log in again.");
      } else {
        setHandbookError(
          error?.message || "Failed to load handbook. Please try again."
        );
      }
    } finally {
      setHandbookLoading(false);
    }
  };

  const handleCloseHandbook = () => {
    setHandbookOpen(false);
    if (handbookUrl) {
      URL.revokeObjectURL(handbookUrl);
      setHandbookUrl(null);
    }
    setHandbookError("");
  };

  // useEffect(() => {
  //   if(apiAWSCalledRef.current) {
  //     return
  //   }
  //   apiAWSCalledRef.current = true
  // async function fetchAWSDetails() {

  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_URL}getAWSDetails`
  //     );
  //     const data = response.data;
  //     const { bucketName, region } = data;

  //     setFetchedBucketName(bucketName);
  //     setFetchedRegion(region);
  //     // Now you can use the bucketName and region in your frontend code
  //     console.log("Bucket Name:", bucketName);
  //     console.log("Region:", region);

  //     // Example usage
  //     // initializeS3Client(bucketName, region);
  //   } catch (error) {
  //     console.error("Error fetching AWS details:", error.message);
  //   }
  // }

  //   fetchAWSDetails();
  // }, []);

  const handleLogout = () => {
    fetch(process.env.REACT_APP_API_URL + "logout", {
      method: "GET",
      credentials: "include", // Include cookies in the request
    })
      .then((response) => {
        if (response.ok) {
          navigate("/login");
          window.location.reload();
        } else {
          throw new Error("Failed to logout");
        }
      })
      .catch((error) => {
        console.error("Logout error:", error);
        // Handle error, display message to the user, etc.
      });
  };

  useEffect(() => {
    if (apiCalledRef.current) return;
    apiCalledRef.current = true;

    axios
      .get(process.env.REACT_APP_API_URL + "profilepage", {
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.reload) {
          document.cookie =
            "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          window.location.reload();
        } else {
          setLoggedUser(response.data);
          setId(response.data._id);
          setEmployeeId(response.data.employeeId);
        }
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
        // Handle error...
      });
  }, []);

  // const fetchData = async () => {
  //   try {
  //     const response = await axios.get(
  //       process.env.REACT_APP_API_URL + "dashboard",
  //       {
  //         withCredentials: true, // Include credentials (cookies) in the request
  //       }
  //     );

  //     setUserRole(response.data.role);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     // Handle the error (e.g., show an error message)
  //     if (
  //       error.response &&
  //       error.response.data &&
  //       error.response.data.message === "Unauthorized"
  //     ) {
  //       // If unauthorized, navigate the user to the login screen
  //       navigate("/login");
  //     }
  //   }
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }

  let profilePic;
  if (loggedUser.profilepic && employeeId) {
    profilePic = `https://${fetchedBucketName}.s3.${fetchedRegion}.amazonaws.com/${getCalendarPdfUrl()}/employees/${employeeId}/profile-picture/${loggedUser.profilepic
      }`;
  }
  return (
    <AppBar
      sx={{
        position: "sticky",
        background: "none",
        boxShadow: "none",
        backgroundColor: `#f0f2f5`,
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        {/* LEFT SIDE */}
        <FlexBetween>
          <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
            <MenuIcon sx={{ color: theme.palette.background.text }} />
          </IconButton>
        </FlexBetween>

        {/* RIGHT SIDE */}
        <FlexBetween gap="1.5rem">
          {/* <IconButton onClick={() => dispatch(setMode())}>
            {theme.palette.mode === "light" ? (
              <DarkModeOutlined sx={{ fontSize: "25px", color: "white" }} />
            ) : (
              <LightModeOutlined sx={{ fontSize: "25px", color: "black" }} />
            )}
          </IconButton> */}

          <Tooltip title="Employee Handbook">
            <IconButton onClick={handleOpenHandbook}>
              <MenuBookOutlined sx={{ color: "#04497a", fontSize: "32px" }} />
            </IconButton>
          </Tooltip>

          <FlexBetween>
            <Button
              onClick={handleClick}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                textTransform: "none",
                gap: "1rem",
              }}
            >
              {/* <Avatar src={`${process.env.REACT_APP_API_URL}public/employees/${loggedUser.employeeId}/profile-picture/${loggedUser.profilepic}`} sx={{ width: "32px", height: "32px" }} /> */}
              {/*     src={`https://ivtree-connect.s3.ap-south-1.amazonaws.com/${getCalendarPdfUrl()}/employees/${user.employeeId}/profile-picture/${user.profilepic}`} */}
              <Avatar src={profilePic} sx={{ width: "32px", height: "32px" }} />
              <div>
                <h3
                  style={{
                    color: "black",
                    margin: "0px",
                    height: "20px",
                    padding: "0px 5px",
                  }}
                >{`${loggedUser.name}`}</h3>
                <h4
                  style={{
                    color: "black",
                    margin: "0px",
                    height: "20px",
                    padding: "0px 5px",
                  }}
                >
                  {loggedUser.role
                    ? `(${capitalizeFirstLetter(loggedUser.role)})`
                    : ""}
                </h4>
              </div>
              <ArrowDropDownOutlined
                sx={{ color: theme.palette.secondary[300], fontSize: "25px" }}
              />
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={isOpen}
              onClose={handleClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
              <Link
                to="/profilepage"
                onClick={handleClose}
                style={{
                  textDecoration: "none",
                  color: theme.palette.mode === "light" ? "black" : "white",
                }}
              >
                <MenuItem>My Profile</MenuItem>
              </Link>
              <MenuItem>
                <Link
                  to="/resetpassword"
                  onClick={handleClose}
                  style={{
                    textDecoration: "none",
                    color: theme.palette.mode === "light" ? "black" : "white",
                  }}
                >
                  Reset Password
                </Link>
              </MenuItem>
              <Link
                to="#"
                onClick={handleLogout}
                style={{
                  textDecoration: "none",
                  background: "transparent",
                  width: "100%",
                  color: theme.palette.mode === "light" ? "black" : "white",
                }}
              >
                <MenuItem>Logout</MenuItem>
              </Link>

              {userRole === "admin" || userRole === "superadmin" ? (
                <MenuItem>
                  <Link
                    to="databasesettings"
                    onClick={handleClose}
                    style={{
                      textDecoration: "none",
                      background: "transparent",
                      width: "100%",
                      color: theme.palette.mode === "light" ? "black" : "white",
                    }}
                  >
                    Admin Panel
                  </Link>
                </MenuItem>
              ) : null}
            </Menu>
          </FlexBetween>
        </FlexBetween>
      </Toolbar>
      <ThemeProvider theme={lightTheme}>
        <Dialog
          open={handbookOpen}
          onClose={handleCloseHandbook}
          maxWidth="lg"
          fullWidth
          sx={{
            "& .MuiDialog-paper": {
              height: "90vh",
              m: 2,
              backgroundColor: "#ffffff",
              borderRadius: "16px",
              overflow: "hidden",
            },
          }}
        >
          <DialogTitle
            sx={{
              m: 0,
              p: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: "#04497a",
              fontWeight: "bold",
              backgroundColor: "#ffffff",
            }}
          >
            Employee Handbook
            <IconButton onClick={handleCloseHandbook} sx={{ color: "#04497a" }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent
            sx={{
              p: 2,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              backgroundColor: "#ffffff",
            }}
          >
            {handbookLoading ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <CircularProgress sx={{ color: "#04497a" }} />
                <Typography>Loading handbook...</Typography>
              </Box>
            ) : handbookError ? (
              <Typography sx={{ color: "#666" }}>{handbookError}</Typography>
            ) : handbookUrl ? (
              <iframe
                src={handbookUrl}
                title="Employee Handbook"
                width="100%"
                height="100%"
                style={{
                  border: "none",
                  borderRadius: "8px",
                  backgroundColor: "#ffffff",
                }}
              />
            ) : null}
          </DialogContent>
          <DialogActions
            sx={{
              px: 3,
              py: 2,
              backgroundColor: "#ffffff",
              borderTop: "1px solid #e0e0e0",
              justifyContent: "flex-start",
            }}
          >
            {handbookAccepted ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CheckCircleIcon sx={{ color: "green" }} />
                <Typography sx={{ color: "#04497a", fontWeight: "bold" }}>
                  Accepted
                  {handbookAcceptedAt
                    ? ` on ${new Date(handbookAcceptedAt).toLocaleDateString()}`
                    : ""}
                </Typography>
                <FormControlLabel
                  sx={{ ml: 1 }}
                  control={
                    <Checkbox checked disabled sx={{ color: "#04497a" }} />
                  }
                  label={
                    <Typography sx={{ fontSize: "13px", color: "#666" }}>
                      I have read, understood and agree to comply with the
                      Employee Handbook.
                    </Typography>
                  }
                />
              </Box>
            ) : (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={false}
                    onChange={handleHandbookAcceptChange}
                    sx={{
                      color: "#04497a",
                      "&.Mui-checked": { color: "#04497a" },
                    }}
                  />
                }
                label={
                  <Typography sx={{ fontSize: "13px", color: "#333" }}>
                    I have read, understood and agree to comply with the
                    Employee Handbook.
                  </Typography>
                }
              />
            )}
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    </AppBar>
  );
};

export default Navbar;
